<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>laden</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important" variant="warning"></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-row style="height:40vh;margin:0" class="welcome-picture">
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8" style="height:100%">
          <div class="language">
            <template>
              <b-dropdown left split text="language" 
                class="language-dropdown-white" 
                toggle-class="toggle-language-white" 
                split-class="split-language-white" 
                style="font-size: 12px;"
              >
                <template #button-content>
                  <img
                    :src="currentLanguageFlag"
                    style="width:28px; height:19px; border-radius:2px;"
                  >
                </template>

                <!-- Dropdown Items -->
                <b-dropdown-item @click="selectLanguage('en')">
                  <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                  English
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('fr')">
                  <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                  Français (French)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('de')">
                  <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                  Deutsch (German)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('es')">
                  <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                  Español (Spanish)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('it')">
                  <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                  Italiano (Italian)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('nl')">
                  <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                  Nederlands (Dutch)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('pt')">
                  <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                  Português (Portuguese)
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </div> 
          <div class="welcome-overlay">
            <h1 class="main-title"><span style="color: rgb(195,147,130)">WYNE</span>LOVER</h1>
            <p class="main-subtitle">gemaakt door wijnliefhebbers – voor wijnliefhebbers</p>
          </div>
        </b-col>
      </b-row> 
      <b-row>
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8">
          <p class="w-title">Wij zijn een groep gepassioneerde wijnliefhebbers.</p>
          <p class="w-text">Onze missie is om de digitale wijnervaring te verbeteren op een open en niet-commerciële manier. Daarom hebben we <b>WyneLover</b> opgericht.</p>
          <p class="w-text">In een eerste fase ontwikkelen we een trilogie van onderling verbonden online applicaties: WyneMaker, WyneCellar en WyneTaster.</p>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynemaker.com"><b>www.wynemaker.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Voor wijnproducenten om gedetailleerde informatie te delen over hun wijndomein en wijnen.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynecellar.com"><b>www.wynecellar.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Voor wijnliefhebbers om hun persoonlijke wijnkelder te beheren en organiseren.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynetaster.com"><b>www.wynetaster.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Om wijnproeverijen te organiseren of eraan deel te nemen, en om je proefnotities te beheren.</p>
            </b-col>
          </b-row>

          <p class="w-text">Zodra de WyneDatabase voldoende is gevuld door producenten die de WyneMaker-app gebruiken, willen we deze delen met de wereld via een open API — ten voordele van wijnliefhebbers, professionals en ontwikkelaars.</p>
          
          <hr>

          <p class="w-title">Hoe kun je ons helpen?</p>
          <p class="w-subtitle">Actieve steun.</p>
          <p class="w-text">We zijn op zoek naar gepassioneerde vrijwilligers met uiteenlopende vaardigheden om ons te helpen het project af te ronden en te promoten:</p>
          <p class="w-text" style="margin:15px">&#9642; marketing en promotie</p>
          <p class="w-text" style="margin:15px">&#9642; wijnkennis (regionaal of algemeen)</p>
          <p class="w-text" style="margin:15px">&#9642; webdesign, UI/UX</p>
          <p class="w-text" style="margin:15px">&#9642; taal- en communicatievaardigheden in verschillende landen</p>
          <p class="w-text" style="margin:15px">&#9642; contacten met wijnproducenten, verenigingen en wijnmagazines</p>
          <p class="w-text">Als je enthousiast bent over het idee om mee te bouwen aan de digitale toekomst van wijn, en je wilt ons vrijwilligersteam versterken, horen we graag van je.</p>
          <p class="w-text">Interesse om een <b>WyneBassador</b> te worden?</p>
          <p class="w-text">Stuur een e-mail naar <b>admin@wynelover.com</b> en vertel ons met welke vaardigheden jij kunt bijdragen aan dit project.</p>
          
          <p class="w-subtitle">Passieve steun.</p>
          <p class="w-text">We willen dit project open en niet-commercieel houden. Dat betekent dat we volledig afhankelijk zijn van donaties. Als je waarde hecht aan wat we bouwen en ons wilt steunen, klik dan op de doneerknop hieronder.</p>

          <hr>

          <b-row>
            <b-col class="text-left">
              <b-button v-on:click="onBack()" class="w-button-pink">terug</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button v-on:click="onDonate()" class="w-button-green">doneer</b-button>
            </b-col>
          </b-row>
          <br>    
        </b-col>
      </b-row>
      <br>  
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WineryWelcome',
     computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },  
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },
      previousPage() {
        return this.$store.state.previous_page
      },
    },
    data() {
      return {
        debug: false, 
        isLoading: true,
      }
    }, 
    mounted() {
      this.isLoading = false
    },
    methods: {
      onBack() {
        this.$store.commit('setPage','Index')
        this.$router.push({path:'/'} );
      },
      onDonate() {
        window.open('https://www.paypal.com/donate/?hosted_button_id=968LLYKG8YBP6');
      },
      
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("Login.selectLanguage: START");
        this.language = language
        this.$store.commit('setLanguage',language)

        if (local_debug || this.debug) console.log("Login.selectLanguage: language set to ", language);

        if (local_debug || this.debug) console.log("Login.selectLanguage: STOP");
      }, 

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>

<style>
@import url("../../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100vw;
    height:auto;
    
    background-image: url("../../assets/img/header.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  width:100%;
  max-width: none !important; 
  position: relative;
  top: 10vh;
}

.language {
  position: fixed;
  top: 5px;
  left: 5px;
  color: white;
  z-index: 10;
}
</style> 